// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amGOmEOylkLxThxflo5x{flex-direction:column;display:flex}.i9rxEK1yp0XIOyY8jFqI{flex-direction:column;gap:1px;display:flex}.iyDMBCdvJEoUgdq_mFif{align-items:center;gap:8px;margin-bottom:20px;display:flex}.bsGia3znNmgnrVikExqK{flex-direction:column;gap:8px;display:flex}.xYbrvzh_zI0Mn1Vsh1zV{--background-neutral-default:var(--background-primary-inverted-primary);background:var(--black-10);border-radius:10px;width:-webkit-fit-content;width:fit-content;padding:4px}.O58XShlH8QXdDaba6hul{margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timePeriodInfo": `amGOmEOylkLxThxflo5x`,
	"planInfo": `i9rxEK1yp0XIOyY8jFqI`,
	"planHeader": `iyDMBCdvJEoUgdq_mFif`,
	"planDetails": `bsGia3znNmgnrVikExqK`,
	"tabs": `xYbrvzh_zI0Mn1Vsh1zV`,
	"periodSuffix": `O58XShlH8QXdDaba6hul`
};
export default ___CSS_LOADER_EXPORT___;
